import { Component, Input } from '@angular/core';
import { FormFieldBase } from '../dynamic-form-field/components/dynamic-form-light/models/form-field-base';
import { MetadataExt } from '../../models/metadati/metadata';

@Component({
  selector: 'app-metadata-dynamic-view',
  templateUrl: './metadata-dynamic-view.component.html',
  styleUrls: ['./metadata-dynamic-view.component.css']
})
export class MetadataDynamicViewComponent {

  @Input() metadati!: MetadataExt[];

  ngOnChanges(){
    this.metadati.sort((a, b) => a.order - b.order).map(obj => obj);
  }

  truncateText(text: string, maxLength: number): string {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }

}
